/* src/components/landing/LpTrustBar.jsx */
import React from 'react';

const BANKS = ['BRB', 'Santander', 'Itaú', 'Inter', 'Bradesco', 'Caixa'];

export default function LpTrustBar() {
  return (
    <section style={{ padding: '60px 0', borderTop: '1px solid var(--border)', borderBottom: '1px solid var(--border)' }}>
      <div className="container" style={{ textAlign: 'center' }}>
        <p style={{ fontSize: '0.8rem', color: 'var(--text-muted)', fontWeight: 500, marginBottom: 30 }}>
          Simulações calibradas com dados oficiais dos maiores bancos do Brasil
        </p>
        <div className="trust-row" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 48, flexWrap: 'wrap', opacity: 0.5 }}>
          {BANKS.map(b => (
            <span key={b} style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--primary)', letterSpacing: '0.02em' }}>{b}</span>
          ))}
        </div>
      </div>
    </section>
  );
}
